// extracted by mini-css-extract-plugin
export default {"rankCell":"eFJifngq_ZSfImjWxez5","topThree":"FVNaskGSgs4VFccCvRou"};